module.exports = __webpack_public_path__ + "img/support.a4fa0e68.png";